import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import smoothscroll from 'smoothscroll-polyfill';
import { localState } from '../../../redux/actions/buddyBooks';
import { panelClosing, settingsPanel } from '../../../redux/actions/settings';
import "./styles.scss";

let scrollFlag = false;
let groupIndex;

class StoryPageParagraph extends Component {
    constructor(props) {
        super(props);

        this.state = {
            groupedSection: [],
            storySegment: {},
            analysis: {},
            index: this.props.index,
            fadeToggle: this.props.fadeToggle,
            fadeProp: null,
            textAnalysis: null,
            wordScore: []
        };
    }

    addAlpha = (color, opacity) => {
        // coerce values so ti is between 0 and 1.
        const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
        return color + _opacity.toString(16).toUpperCase();
    }

    getGroupedSections = (allStorySegment) => {
        if (allStorySegment) {
            const { storyChapters } = this.props;
            let groupedArr = [];
            let text = '';
            let obj = {};
            let sections = [];
            allStorySegment.forEach((segment, i) => {
                let newGroupNumber;
                let chapterItem = !_.isEmpty(storyChapters) && storyChapters.find(item => item.sectionIndex == segment.section);
                if (i < allStorySegment.length - 1) {
                    newGroupNumber = allStorySegment[i + 1].groupNumber;
                } else {
                    newGroupNumber = null;
                }
                if (segment.groupNumber === newGroupNumber) {
                    text += segment.text + ' ';
                    if (chapterItem) {
                        sections.push({
                            text: segment.text,
                            section: segment.section,
                            groupNumber: segment.groupNumber,
                            type: segment.type,
                            chapter: chapterItem.chapterName
                        });
                    } else {
                        sections.push({
                            text: segment.text,
                            section: segment.section,
                            groupNumber: segment.groupNumber,
                            type: segment.type
                        });
                    }
                } else {
                    if (text) {
                        text += segment.text;
                        sections.push({
                            text: segment.text,
                            section: segment.section,
                            groupNumber: segment.groupNumber,
                            type: segment.type
                        });
                        obj = {
                            text,
                            groupNumber: segment.groupNumber,
                            sections,
                        }
                        groupedArr.push(obj);
                        text = '';
                        sections = [];
                    } else {
                        if (chapterItem) {
                            obj = {
                                text: segment.text,
                                section: segment.section,
                                groupNumber: segment.groupNumber,
                                type: segment.type,
                                chapter: chapterItem.chapterName
                            }
                        } else {
                            obj = {
                                text: segment.text,
                                section: segment.section,
                                groupNumber: segment.groupNumber,
                                type: segment.type
                            }
                        }
                        groupedArr.push(obj);
                    }
                }
            })
            this.setState({ groupedSection: groupedArr });
        }
    }

    pickQueryText = (queryText) => {
        console.log("queryText ", queryText);
        if (this.props.settings && this.props.settings.modalState.isQuestionClicked) {
            this.props.dispatch(localState({ queryText, isNotPronouced: true }));
        }
    }

    componentDidMount() {
        this.getGroupedSections(this.props.allStorySegment);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.bbSettings !== this.props.bbSettings) {
            let sd = document.getElementById("storyDisplay");
            const { fontColor } = nextProps.bbSettings;
            if (sd) {
                sd.style.color = this.addAlpha(fontColor, 0.4);
            }
        }
        const { localData, allStorySegment } = this.props;
        if ((nextProps.allStorySegment !== allStorySegment && localData.isSkippedToSearch) || (localData.isNextHundredStoryAdded)) {
            this.setState({ groupedSection: [] });
            this.getGroupedSections(nextProps.allStorySegment);
            localData.isNextHundredStoryAdded && this.props.dispatch(localState({ isNextHundredStoryAdded: false }))
        }
    }

    componentDidUpdate(props, state) {
        if(props.allStorySegment !== this.props.allStorySegment){
            this.getGroupedSections(this.props.allStorySegment)
        }
        let el = document.getElementById("playSegment");
        let dwf = document.getElementsByClassName("displayScroll_withFocus");
        const { fontColor } = props.bbSettings;
        const { isSkippedToSearch, isSkipStoryUpdated } = this.props.localData;

        if ((el || dwf) && (!scrollFlag || props.settings.panel.settingsPanel || (isSkippedToSearch && isSkipStoryUpdated))) {
            el && (el.style.color = fontColor);

            if (dwf) {
                for (var i = 0; i < dwf.length; i++) {
                    dwf[i].scrollIntoView({
                        block: 'center',
                        inline: 'center'
                    });
                };
            }
            scrollFlag = true;
            this.props.dispatch(panelClosing({ settingsPanel: false }));
            this.props.dispatch(localState({ isSkippedToSearch: false }));
        }

        if (el || dwf) {
            el && (el.style.color = fontColor);
            if (dwf) {
                for (var i = 0; i < dwf.length; i++) {
                    dwf[i].scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                        inline: 'center'
                    });
                };
            }
        }
    }

    componentWillUnmount() {
        scrollFlag = false;
    }

    render() {
        smoothscroll.polyfill();
        const { analysis, highlightWordIndex, allStorySegment, index, blobIndex } = this.props;
        // const groupNumber = index && allStorySegment[index].groupNumber;
        let groupNumber = allStorySegment.find(segment => segment.section == index)?.groupNumber;
        const { fontColor, highlightColor, highlightMode, fontSize, highlightSentence, followAlong } = this.props.bbSettings
        return (
            <div className="innerSegmentContainer" style={{ fontSize: fontSize + "em", fontFamily: 'sans-serif' }}>
                {
                    this.state.groupedSection && this.state.groupedSection.length > 0 &&
                    this.state.groupedSection.map((segment, i) => {
                        let segmentArr = [];
                        let computerText = '';
                        if ((groupNumber || groupNumber === 0) && segment.groupNumber === groupNumber && segment.sections) {
                            segment.sections.map(({ text }) => {
                                computerText += text + ' ';
                            })
                            if (computerText.includes('.')) {
                                computerText = computerText.replace(/\./, '. ');
                            }
                            segmentArr = computerText.split(" ");
                        }
                        if (segment.sections) {
                            return (
                                <div
                                    key={i}
                                    id='storyDisplay'
                                    className="displayScroll"
                                    style={{ color: this.addAlpha(fontColor, 0.4) }}
                                >
                                    {_.isEmpty(segmentArr) ?
                                        segment.sections.map(item => {
                                            return (
                                                <>
                                                    {
                                                        item.chapter &&
                                                        <div>
                                                            <div className='chapterName' style={{ color: fontColor }}>{item.chapter}</div>
                                                            <hr />
                                                        </div>
                                                    }
                                                    <span
                                                        id='storyDisplay'
                                                        className="displayScroll indivisual_segment_text"
                                                        style={{ color: this.addAlpha(fontColor, 0.4) }}
                                                    > {item.text} </span>
                                                </>
                                            )
                                        }) :
                                        <span key={i} id="playSegment" className="displayScroll_withFocus">
                                            {segment.sections.map((section, si) => {
                                                let textArr = section.text.split(" ");
                                                return (
                                                    <>
                                                        {
                                                            section.chapter &&
                                                            <div>
                                                                <div className='chapterName' style={{ color: fontColor }}>{section.chapter}</div>
                                                                <hr />
                                                            </div>
                                                        }
                                                        {textArr.map((item, index) => {
                                                            let highlightToggle = false;
                                                            let bgHighlight = {
                                                                background: highlightColor,
                                                                boxShadow: "0px 1px 3px #222, 0px 1px 1px #333",
                                                                borderRadius: 4,
                                                            }
                                                            let sentenceHighlight = {
                                                                background: highlightColor,
                                                            }
                                                            let highlightStyle = bgHighlight;
                                                            if ((this.props.playRecording || this.props.playComputer) && (highlightWordIndex === index)) {
                                                                highlightToggle = highlightMode;
                                                            } else highlightToggle = false;
                                                            if (highlightSentence && blobIndex == si && section.type == "Computer") {
                                                                highlightToggle = true;
                                                                highlightStyle = sentenceHighlight;
                                                            }
                                                            return (
                                                                section.type == "Computer" ?
                                                                    <span
                                                                        key={index}
                                                                        style={highlightToggle && si == blobIndex ? highlightStyle : { background: "" }}
                                                                        className='indivisual_segment_text'
                                                                    > {item} </span>
                                                                    : <span
                                                                        key={index}
                                                                        className='indivisual_segment_text'
                                                                        onMouseEnter={(e) => {
                                                                            if (followAlong)
                                                                                e.target.style.background = highlightColor;
                                                                        }}
                                                                        onMouseOut={(e) => {
                                                                            e.target.style.background = "";
                                                                        }}> {item} </span>
                                                            )
                                                        })
                                                        }

                                                    </>
                                                )
                                            })
                                            }
                                        </span>
                                    }
                                </div>
                            )
                        } else if (segment.section === index) {
                            segmentArr = segment.text.split(" ");
                            groupIndex = segment.groupNumber;
                            return (
                                <div key={i} id="playSegment" className="displayScroll_withFocus">
                                    {
                                        segment.chapter &&
                                        <div>
                                            <div className='chapterName' style={{ color: fontColor }}>{segment.chapter}</div>
                                            <hr />
                                        </div>
                                    }
                                    {segmentArr.map((item, index) => {
                                        let highlightToggle = false;
                                        let bgHighlight = {
                                            background: highlightColor,
                                            boxShadow: "0px 1px 3px #222, 0px 1px 1px #333",
                                            borderRadius: 4
                                        }
                                        let sentenceHighlight = {
                                            background: highlightColor,
                                        }
                                        let highlightStyle = bgHighlight;

                                        if ((this.props.playRecording || this.props.playComputer) && (highlightWordIndex === index)) {
                                            highlightToggle = highlightMode;
                                        } else highlightToggle = false;
                                        if (highlightSentence) {
                                            highlightToggle = true;
                                            highlightStyle = sentenceHighlight;
                                        }
                                        return (
                                            segment.type == "Computer" ?
                                                <span
                                                    key={index}
                                                    style={highlightToggle && segment.type == "Computer" ? highlightStyle : { background: "" }}
                                                    className='indivisual_segment_text'
                                                > {item} </span>
                                                : <span
                                                    key={index}
                                                    className='indivisual_segment_text'
                                                    onMouseEnter={(e) => {
                                                        if (followAlong)
                                                            e.target.style.background = highlightColor;
                                                    }}
                                                    onMouseOut={(e) => {
                                                        e.target.style.background = "";
                                                    }}
                                                > {item} </span>)
                                    })}
                                </div>
                            )
                        } else {
                            return (
                                <div
                                    key={i}
                                    id='storyDisplay'
                                    className="displayScroll"
                                    style={{ color: this.addAlpha(fontColor, 0.4) }}
                                >
                                    {
                                        segment.chapter &&
                                        <div>
                                            <div className='chapterName' style={{ color: fontColor }}>{segment.chapter}</div>
                                            <hr />
                                        </div>
                                    }
                                    <span
                                        className='indivisual_segment_text'
                                    > {segment.text} </span>
                                </div>
                            )
                        }
                    })}
            </div>
        )
    }
}

const mapState = ({ platform: { settings, analysis: { localData } } }) => {
    return {
        settings,
        localData
    }
};

export default connect(mapState)(StoryPageParagraph);